<template>
    <v-container fluid>
        <resource-form
            :model="model"
            @saved="saved"
            :titlePrefix="$t('roles.edit.texts.title-prefix')"
            :isEdit="true"
            v-if="this.model"
        ></resource-form>

        <template v-else>
            <v-row>
                <v-col class="text-center">
                    <v-progress-circular
                        :size="50"
                        color="primary"
                        indeterminate
                    ></v-progress-circular>
                </v-col>
            </v-row>
        </template>
    </v-container>
</template>

<script>
import Model from '@/models/Role'
import Form from './Form'

export default {
    props: ['id'],

    data: () => {
        return {
            model: null,
        }
    },

    components: {
        'resource-form': Form,
    },

    methods: {
        async getResource() {
            let model = new Model()

            let res = await model.find(this.id)

            if (!res) return

            this.model = res
        },

        saved() {
            this.$router.push({ name: this.$t('roles.routes.index') })
        },
    },

    created() {
        this.getResource()
    },
}
</script>
